import type { ComponentType } from "react";

import { MobileAppSlide } from "./slides/MobileAppSlide/MobileAppSlide";
import { QualityProgramSlide } from "./slides/QualityProgramSlide/QualityProgramSlide";

interface SideCarouselSlide {
  key: string;
  /** Renders its own background and content, and fills the frame it's given */
  Slide: ComponentType;
}

const sideCarouselSlides: SideCarouselSlide[] = [
  { key: "quality-program", Slide: QualityProgramSlide },
  { key: "mobile-app", Slide: MobileAppSlide },
];

export { sideCarouselSlides, type SideCarouselSlide };
